import Checkbox from './Checkbox'

export default Checkbox



// WEBPACK FOOTER //
// ./src/app/elements/Checkbox/index.js